export default __webpack_public_path__ + "static/media/JobDetails_banner.11d9a475.png";